import { Link } from 'react-router-dom';
import React from 'react';
import { useTranslation } from 'react-i18next';

const PortfplioDivider = () => {
  const {t , i18n} = useTranslation()
  return (
    <div className="divider-conrainer">

    <div className='Divider flex-col !items-center !justify-center !gap-12'>
      <h3 className='text-center font-bold'>
      {t("We’re Ready to Bring Bigger & Stronger")}  <br/> {t("Projects")}
      </h3>
      <Link to='/bookNow' className='link'>{t("Book now")}</Link>
    </div>
    </div>
  );
}

export default PortfplioDivider;
